<template>
  <div>
    <div class="login_modal" @touchmove.prevent v-if="modalDate" @click="modalshow()">
      <div class="modal_conter">
        <div class="modal_code">
          <div class="code_one">
            <img src="../assets/openewmtit.png" alt="" srcset="">
          </div>
          <div class="code_two">
            扫描二维码下载APP
          </div>
        </div>
      </div>
    </div>
    <div class="first_box">
      <div class="first_box_fixed">
        <div class="first_box_title">
        <div class="box_title_content">
          <div class="title_content_left">
            <div class="content_left_icon">
              <img src="../assets/logo.png" alt="" srcset="">
            </div>
            <div class="content_left_text">
              <img src="../assets/invite_toplo.png" alt="" srcset="">
            </div>
          </div>
          <div class="title_content_right">
              <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="首页" name="first"></el-tab-pane>
                <el-tab-pane label="找粮商家入驻" name="second"></el-tab-pane>
                <el-tab-pane label="热点资讯" name="third"></el-tab-pane>
                <el-tab-pane label="帮助中心" name="fourth"></el-tab-pane>
                <el-tab-pane label="举报平台" name="fourts"></el-tab-pane>
                <el-tab-pane label="查快递" name="fourths"></el-tab-pane>
              </el-tabs> -->
              <div @click="findmessagedialog">首页</div>
              <div class="content_line"></div>
              <div>产品介绍</div>
              <div class="content_line"></div>
              <div>商家特权</div>
              <div class="content_line"></div>
              <div>入驻流程</div>
              <div class="content_line"></div>
              <div class="content_right_index">登录</div>
          </div>
        </div>
        </div>
        <!-- <div class="frist_box_line">
        </div> -->
        <!-- <div class="first_box_code">
          <div class="box_code_content">
            <div class="code_content_img">
              <div class="content_img_box">
                <img src="../assets/openewmtit.png" alt="" srcset="">
              </div>
            </div>
            <div class="code_content_text">
              <div>扫码下载</div>
              <div>App专享优惠</div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="frist_box_content">
        <div class="box_content_banner">
          <div class="content_banner_left">
            <img src="../assets/bannerrmb.png" alt="" srcset="">
          </div>
          <div class="content_banner_center">
            <p>来找粮APP成为认证商家</p>
            <p style="font-size: 0.3rem; font-weight: 400;">找粮认证全面升级 诚邀优质商家</p>
          </div>
          <div class="content_banner_right" v-if="loginDate">
            <div class="banner_right_box">
              <div class="right_box_one">账户登录</div>
              <div class="right_box_two">
                <div class="box_two_lef">+86</div>
                <div class="box_two_rig">
                  <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  >
                  <el-form-item  prop="tel">
                    <el-input
                      v-model="ruleForm.tel"
                      placeholder="请输入手机号"
                      οninput="value=value.replace(/[^\d]/g,'');if(value.length > 11)value = value.slice(0, 11)"
                    ></el-input>
                  </el-form-item>
                </el-form>
                </div>
              </div>
              <div class="right_box_thr">  
                <el-input
                    show-password
                    placeholder="请输入密码"
                    v-model="input4">
                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                  </el-input> 
              </div>
              <div class="right_box_fou"  @click="modalHide()">登录</div>
              <div class="right_box_fiv">没有账号？去<span class="box_fiv_zc" @click="loginTo()">注册</span></div>
              <div class="right_box_six"><el-checkbox v-model="checked" style="margin-right: .1rem;"></el-checkbox>已阅读并同意<a class="usetext">《用户协议》</a>及<a class="usetext">《隐私协议》</a></div>
            </div>
          </div>
          <div class="content_banner_right" v-if="!loginDate">
            <div class="banner_right_box">
              <div class="right_box_one">账户注册</div>
              <div class="right_box_two">
                <div class="box_two_lef">+86</div>
                <div class="box_two_rig">
                  <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  >
                  <el-form-item  prop="tel">
                    <el-input
                      v-model="ruleForm.tel"
                      placeholder="请输入手机号"
                      οninput="value=value.replace(/[^\d]/g,'');if(value.length > 11)value = value.slice(0, 11)"
                    ></el-input>
                  </el-form-item>
                </el-form>
                </div>
              </div>
              <div class="right_box_thrs">  
                <el-input
                    show-password
                    placeholder="请输入密码"
                    v-model="input4">
                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                  </el-input> 
              </div>
              <div class="right_box_thrs">  
                <div class="box_thrs_le">
                  <el-input
                    placeholder="请输入短信验证码" 
                    v-model="input3">
                    <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                  </el-input>
                </div>
                <div class="box_thrs_ri" @click="modalHide()">
                  获取验证码
                </div>
              </div>
              <div class="right_box_fou"  @click="modalHide()">登录</div>
              <div class="right_box_fiv">已有账号？去<span class="box_fiv_zc" @click="loginTo()">登录</span></div>
            </div>
          </div>
        </div>
        <div class="box_content_info">
          <div class="content_info_list">
            <div class="info_list_title">
              <!-- <div>现货信息</div> -->
              <!-- <div></div> -->
            </div>
            <div class="info_list_conter">
              <div class="list_conter_one">
                <div class="conter_otr_img"><img src="../assets/login01.png" alt="" srcset=""></div>
                <div class="conter_otr_tex">专属铭牌</div>
              </div>
              <div class="list_conter_one">
                <div class="conter_otr_img"><img src="../assets/login02.png" alt="" srcset=""></div>
                <div class="conter_otr_tex">行情分析</div>
              </div>

              <div class="list_conter_one">
                <div class="conter_otr_img"><img src="../assets/login03.png" alt="" srcset=""></div>
                <div class="conter_otr_tex">资质证明</div>
              </div>
            </div>
            <div class="info_list_conters">
              <div class="list_conters_o">平台入驻优势</div>
              <div class="list_conters_t"></div>
              <div class="list_conters_s">
                <div class="conters_s_i"><img src="../assets/login04.png" alt="" srcset=""></div>
                <div class="conters_s_i"><img src="../assets/login05.png" alt="" srcset=""></div>
                <div class="conters_s_i"><img src="../assets/login06.png" alt="" srcset=""></div>
                <div class="conters_s_i"><img src="../assets/login07.png" alt="" srcset=""></div>
              </div>
            </div>
            <div class="info_list_contert">
              <div class="list_conters_o">入驻流程</div>
              <div class="list_conters_t"></div>
              <div class="list_contert_s">
                <img src="../assets/login08.png" alt="" srcset="">
              </div>
              <div class="conter_rz"  @click="toTop">我要入驻</div>
            </div>


            <div class="info_list_code">
              <div class="list_code_img">
                <img src="../assets/openewmtit.png" alt="" srcset="">
              </div>
              <div class="list_code_text">扫描二维码下载APP</div>
            </div>
          </div>
        </div>
        <div class="frist_box_foot">
          <div class="box_foot_text">合肥预见未来信息科技有限公司</div>
          <div class="box_foot_text">公司地址：合肥市蜀山区高新技术开发区超远科技园C栋206</div>
          <div class="box_foot_text">联系电话：0551-65353167</div>
          <div class="box_foot_text">公司邮箱：postmaster@foresee-future.com</div>
          <div class="box_foot_text">
            <div class="imgs"><img src="../assets/wanicon.png" alt=""></div>
            <div class="infos">皖ICP备2021000115号-1</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  // 定义属性
  data() {
    return {
      // activeName: 'first'
      loginDate:false,
      checked: false,
      modalDate:false,
      input4: '',
      input3: '',
      ruleForm: {
      tel: "", // 手机号
      },
      rules: {
        tel: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { min: 11, message: "手机号格式不正确", trigger: "blur" }
        ]},

    }
  },
  // 计算属性，会监听依赖属性值随之变化s
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // handleClick(tab, event) {
    //     console.log(tab, event);
    //   }
    findmessagedialog(promessage) {
      let othermessage;
        othermessage = this.$router.resolve({
          path: '/',
          query: {
          },
        })
      window.open(othermessage.href, '_blank')
    },
    loginTo() {
      this.loginDate = !this.loginDate
    },
    modalHide() {
      this.modalDate = !this.modalDate
      this.stop()
    },
    modalshow(){
      this.modalDate = !this.modalDate
      this.move()
    },
        //禁止滚动
    stop(){
      var mo=function(e){
　　  e.preventDefault();
　　     };
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    //取消滑动限制
    move(){
        var mo=function(e){
　　　　　　e.preventDefault();
　　　　　};
        document.body.style.overflow='';//出现滚动条
        document.removeEventListener("touchmove",mo,false);
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
  },
  components: {

  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
/* html,body{
  width: 100%;
  height: 100%;
} */
.login_modal {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #00000080;
  z-index: 999;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}
.modal_conter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 4.55rem;
  height: 5.65rem;
  background-image:url(../assets/opencornmodalback.png);
  background-repeat: no-repeat;
  background-size:4.55rem 5.65rem;
}
.modal_code {
  width: 4rem;
  height: 4rem;
  margin: auto;
  /* border: 1px solid #2D2D2D; */
}
.code_one {
  margin:.6rem auto;
  margin-top: 2.15rem;
  width: 2.22rem;
  height: 2.22rem;
  /* border: 1px solid #2D2D2D; */
}
.code_two {
  font-size: .18rem;
  color: #6E6E6E;
  font-weight: 600;
  text-align: center;
}
.first_box {
  /* width: 18.8rem;
  height: 10rem; */
  /* background: #FF6E00; */
}
.first_box_fixed {
  width: 100%;
  position: fixed;
  top: 0px;
  z-index: 9;
}
.first_box_title {
  height: 1.045rem;
  border: 1px solid #fff;
  background: #fff;
}
.box_title_content {
  margin: auto;
  display: flex;
  width: 63%;
  height: 100%;
  /* border: 1px solid #FF6E00; */
}
.title_content_left {
  margin: auto 0;
  display: flex;
  width: 3rem;
  height: .61rem;
  /* border: 1px solid #FF6E00; */
}
.title_content_right {
  display: flex;
  margin:auto 0;
  width: 8.8rem;
  height: .3rem;
  line-height: .3rem;
  font-size: 0.16rem;
  cursor: pointer;
  /* border: 1px solid #FF6E00; */
}
.content_right_index {
  font-weight: 600;
  color: #FF9127;
}
.usetext {
  color: #FF9127;
}
.content_left_icon {
  width: 0.61rem;
  height: 0.61rem;
  /* border: 1px solid #FF6E00; */
}
.content_left_icon img {
  width: 0.61rem;
  height: 0.61rem;
}
.content_left_text {
  margin-left: .1rem;
  width: 1.5rem;
  height: .6rem;
  /* border: 1px solid #FF6E00; */
}
.content_left_text img {
  width: 1.5rem;
  height: .6rem;
}
>>>.el-tabs__item.is-active {
  color: #FF6E00;
}
>>>.el-tabs__item:hover {
  color: #FF6E00;
}
>>>.el-tabs__active-bar {
  background-color: #FF6E00;
}
>>>.el-tabs__item {
  font-size: 16px;
}
>>>.el-tabs__nav-wrap::after {
  background: none;
}
.frist_box_line {
  width: 100%;
  height: .045rem;
  background: #FF6E00;
}
.first_box_code {
  position: fixed;
  top: 6.1rem;
  width: 1.6rem;
  height: 2.15rem;
  line-height: 2.15rem;
  background: #FFF;
}
.box_code_content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 1.4rem;
  height: 1.95rem;
  border: 0.02rem solid #FFE6D3;
}
.code_content_img {
  width: 1.4rem;
  height: 1.5rem;
  /* border: 0.02rem solid red; */
}
.content_img_box {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 1.1rem;
  height: 1.1rem;
}
.content_img_box img{
  width: 1.1rem;
  height: 1.1rem;
}
.code_content_text {
  /* text-align: center; */
  width: 1.4rem;
  height: .44rem;
  /* line-height: .22rem; */
  /* border: 1px solid black; */
}
.code_content_text div{
  font-size: 0.14rem;
  text-align: center;
  width: 1.4rem;
  height: .2rem;
  line-height: .15rem;
  /* border: 1px solid black; */
}

.content_line {
  margin: auto 0.10rem;
  width: 0.01rem;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
  height: 0.18rem;
  background:#6c6c6c;
}
.frist_box_content {
  padding-top: 1.09rem;
  width: 100%;
  /* height: 5.44rem; */
  /* background: #FF9127; */
}
.box_content_banner {
  display: flex;
  /* margin: 0 auto; */
  /* margin-top: 0.59rem; */
  width: 100%;
  height: 4.84rem;
  background: #2D2D2D;
  /* border: 1px solid royalblue; */
}
.content_banner_left {
  margin: 1.18rem .1rem 1.2rem 3rem;
  width: 3rem;
  height: 2.4rem;
  /* background: #FFFFFF; */
}
.content_banner_center {
  margin: 0.45rem;
  padding-top: 1.35rem;
  width: 7rem;
  /* height: 4rem; */
  /* background: #FFFFFF; */
  font-size: 0.45rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFF1CF;
  line-height: 0.8rem;
}
.content_banner_right {
  margin-top: 0.4rem;
  /* margin: 0.4rem; */
  margin-right: 0.4rem;
  width: 4.8rem;
  height: 3.9rem;
  background: #FFFFFF;
}
.banner_right_box {
  margin: 0.4rem;
  width: 4rem;
  height: 3.2rem;
  /* border: 1px solid black; */
}
.right_box_one {
  margin-bottom: 0.4rem;
  font-size: 0.25rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 0.32rem;
}
.right_box_two {
  display: flex;
  margin-bottom: 0.2rem;
  width: 4rem;
  height: 0.4rem;
  background: #FFFFFF;
  /* border: 0.01rem solid #DEDEE8; */
}

.box_two_lef {
  width: 1.3rem;
  height: 0.4rem;
  line-height: .4rem;
  text-align: center;
  background: #F5F4F9;
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #81808E;
  border-left: 0.01rem solid #DEDEE8;
}
.box_two_rig {
  width: 2.7rem;
  height: 0.4rem;
  background: blanchedalmond;
}

.right_box_thr {
  margin-bottom: 0.3rem;
  width: 4rem;
  height: 0.4rem;
  background: #FFFFFF;
  /* border: 0.01rem solid #DEDEE8; */
}
.right_box_thrs {
  display: flex;
  margin-bottom: 0.2rem;
  width: 4rem;
  height: 0.4rem;
  background: #FFFFFF;
}
.box_thrs_ri {
  /* position: absolute; */
  cursor: pointer;
  /* right: 0.8rem; */
  width: 1.3rem;
  height: 0.38rem;
  line-height: .4rem;
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FF6E00;
  text-align: center;
  border: 0.01rem solid #DEDEE8;
  background: #FFF;
  border-left:0px;
}
>>>.el-input__inner {
  height: .4rem;
}
>>>.el-form-item__content  {
  line-height: .4rem;
  font-size: .14rem;
}
.box_thrs_le {
  width: 2.7rem;
  height: 0.4rem;
  background: blanchedalmond;
}
.right_box_fou {
  margin-bottom: 0.2rem;
  width: 4rem;
  height: 0.4rem;
  line-height: .4rem;
  text-align: center;
  background: #FF6E00;
  border-radius: 0.02rem;
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
}
.right_box_fiv {
  margin-bottom: 0.2rem;
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
>>>.el-input__inner {
  border-radius: 0;
}
>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #333333;
}
.box_fiv_zc {
  cursor: pointer;
  color: #FF6E00;
}
.right_box_six {
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}

.content_banner_img {
  width: 3.3rem;
  height: 3.84rem;
  /* border: 1px solid royalblue; */
}
.content_banner_img img{
  margin-top: .05rem;
  width: 3.3rem;
  height: 3.84rem;
}
.content_banner_text {
  margin-left: 1.45rem;
  width: 3.3rem;
  height: 3.84rem;
  /* border: 1px solid royalblue; */
}
.banner_text_top {
  margin-top: 0.5rem;
  width: 3.3rem;
  height: 1.5rem;
  /* border: 1px solid royalblue; */
}
.banner_text_top img{
  width: 3.3rem;
  height: 1.5rem;
}
@font-face {
	font-family: 'YouSheBiaoTiHei';
	src: url(../font/YouSheBiaoTiHei-2.ttf);
}
.banner_text_bottom {
  font-family: YouSheBiaoTiHei;
  margin: auto;
  margin-top: .5rem;
  font-size: 0.36rem;
  color: #FF6E00;
  width: 2rem;
  height: .6rem;
  text-align: center;
  line-height: .6rem;
  background: #FFFFFF;
  border-radius: 3%;
}
.box_content_info {
  width: 100%;
  /* width: 100vw; */
  /* height: 10.44rem; */
  background: #FAFAFA;
}
.content_info_list {
  padding-top: .2rem;
  margin: auto;
  width: 63%;
  /* width: 100vw; */
  /* height: 10.44rem; */
  /* background: #FFE6D3; */
}
.info_list_code {
  height: 4rem;
  width: 100%;
  /* border: 1px solid black; */
}
.list_code_img {
  margin: .8rem auto;
  margin-bottom: .4rem;
  width: 2.6rem;
  height: 2.6rem;
  /* border: 1px solid black; */
}
.list_code_text {
  margin: 0 auto;
  width: 2rem;
  height: .5rem;
  font-size: 0.22rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;

}
.info_list_conter {
  padding-top: .2rem;
  display: flex;
  margin: auto;
  justify-content: space-around;
  width: 81%;
  font-size: .2rem;
  height: 4rem;
  /* border: 1px solid black; */
}
.list_conter_one {
  width: 2.9rem;
  height: 2.7rem;
  background: #FAFAFA;
  border: 0.01rem solid #DFDFDF;
}
.conter_otr_img {
  margin: .5rem auto;
  margin-bottom: .2rem;
  width: 1.3rem;
  height: 1.3rem;
  /* border: 0.01rem solid #DFDFDF; */
}
.conter_otr_tex {
  width: 2.9rem;
  height: .4rem;
  font-size: 0.26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.4rem;
  text-align: center;
  /* border: 0.01rem solid #DFDFDF; */
}
.info_list_conters {
  padding-top: .2rem;
  /* display: flex; */
  margin: auto;
  /* justify-content: space-around; */
  width: 100%;
  font-size: .2rem;
  height: 5rem;
  /* border: 1px solid black; */
}
.list_conters_o {
  width: 100%;
  text-align: center;
  font-size: 0.4rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
}
.list_conters_t {
  margin: auto;
  margin-top: 0.2rem;
  margin-bottom: 0.8rem; 
  width: 0.54rem;
  height: 0.09rem;
  background: #FF6E00;
}
.list_conters_s {
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 1rem;
  /* border: 1px solid black; */
}
.conters_s_i {
  width: 2.8rem;
  height: 1rem;
  /* border: 1px solid black; */
}

.info_list_contert {
  /* display: flex; */
  margin: auto;
  /* justify-content: space-around; */
  width: 100%;
  font-size: .2rem;
  /* height: 3rem; */
  /* border: 1px solid black; */
}
.list_contert_s {
  margin: auto;
  margin-top: 1.4rem;
  margin-bottom: 1.2rem;
  width: 6.9rem;
  height: .95rem;
}
.conter_rz {
  margin: auto;
  cursor: pointer;
  width: 1.75rem;
  height: 0.66rem;
  background: #FF6E00;
  box-shadow: 0rem 0.13rem 0.3rem 0rem #FFE1C2;
  border-radius: 0.02rem;
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 0.66rem;
  text-align: center;
}
.frist_box_foot {
  width: 100%;
  /* width: 100vw; */
  height: 2.05rem;
  background: #3F3E3E;
}
.box_foot_text {
  position: relative;
  width: 100%;
  /* width: 100vw; */
  height: .41rem;
  line-height: .41rem;
  text-align: center;
  font-size: 0.15rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b1b1b1;
}
.box_foot_text .imgs {
  width: 0.16rem;
  height: 0.16rem;
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  left: 44.25%;
  /* top: 0.02rem; */
}
.box_foot_text .infos {
  display: inline-block;
}

img {
  width: 100%;
  height: 100%;
}
</style>